import React from "react";
import { StyleSheet, View } from "react-native";
import CheckIcon from "app/scenes/CurrentTrackScreen/CheckIcon";
import { MainText } from "app/components/common";
import theme from "app/Theme/Theme";

const styles = StyleSheet.create({
  main: {
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    alignSelf: "center",
    justifyContent: "flex-start",
    marginBottom: 15,
  },
  icon: {
    justifyContent: "flex-start",
    marginRight: 35,
  },
});

interface Props {
  isSmall?: boolean;
  isChecked?: boolean;
  text: string;
  style?: {};
}

const CheckText = ({
  isChecked = false,
  text,
  isSmall = false,
  style = {},
}: Props) => {
  const color = isChecked
    ? theme.colors["brand.500"]
    : theme.colors["neutral.400"];

  return (
    <View style={[styles.main, style]}>
      <View style={styles.icon}>
        <CheckIcon
          color={color}
          width={isSmall ? 14 : 23}
          height={isSmall ? 12 : 17}
        />
      </View>
      <MainText
        variant={isChecked ? "l4-semibold" : "l4-regular"}
        color={isChecked ? "brand.500" : "neutral.400"}
      >
        {text}
      </MainText>
    </View>
  );
};

export default CheckText;
